import React from 'react';
import { Table as Table$1, Skeleton, Flex, Pagination } from '@olist/design-system';
import { TableState } from '../TableState/TableState.js';

function Table({ columns, rows, isLoading, isLoadingComponent, isEmpty, isEmptyComponent, isError, isErrorComponent, pagination, }) {
    if (isLoading)
        return isLoadingComponent ? (isLoadingComponent) : (React.createElement(Table$1, { columns: columns, rows: [...new Array(5)].map((_, index) => ({
                key: index,
                data: columns.map((_, index) => ({
                    key: index,
                    value: React.createElement(Skeleton, { width: "100%" }),
                })),
            })) }));
    if (isError)
        return isErrorComponent ? (isErrorComponent) : (React.createElement(TableState, { "data-testid": "table-state-error", state: "error", text: "Ocorreu um erro inesperado, mas fomos notificados!" }));
    if (isEmpty)
        return isEmptyComponent ? (isEmptyComponent) : (React.createElement(TableState, { "data-testid": "table-state-blank", state: "blank", text: "Nenhum dado foi encontrado, n\u00E3o h\u00E1 nada para exibir! :(" }));
    return (React.createElement(React.Fragment, null,
        React.createElement(Table$1, { columns: columns, rows: rows }),
        pagination && (React.createElement(Flex, { mt: "stack.small", justifyContent: "flex-end" },
            React.createElement(Pagination, { currentPage: pagination === null || pagination === void 0 ? void 0 : pagination.currentPage, pageCount: pagination === null || pagination === void 0 ? void 0 : pagination.pageCount, onPageChange: (newPage) => (pagination === null || pagination === void 0 ? void 0 : pagination.handlePaginationChange) &&
                    (pagination === null || pagination === void 0 ? void 0 : pagination.handlePaginationChange(newPage)) })))));
}

export { Table };
